import React from 'react';
import classNames from 'classnames';
import Switch from '@material-ui/core/Switch';

interface ToggleProps {
  checked: boolean;
  locked: boolean;
  onToggleClick?: () => void;
}

interface ToggleState {
  checkedState?: boolean;
}

export default class PivotToggle extends React.Component<ToggleProps, ToggleState> {
  public static getDerivedStateFromProps(
    nextProps: ToggleProps,
    _prevState: ToggleState
  ) {
    return {
      checkedState: nextProps.checked,
    };
  }

  constructor(props: ToggleProps) {
    super(props);
    this.state = {
      checkedState: props.checked,
    };
  }
  private static defaultProps = {
    locked: false
  }

  public shouldComponentUpdate(nextProps: ToggleProps, nextState: ToggleState) {
    const { checked: lastChecked } = this.props;
    const { checked: nextChecked } = nextProps;

    const { checkedState: lastCheckedState } = this.state;
    const { checkedState: nextCheckedState } = nextState;

    return lastChecked !== nextChecked || lastCheckedState !== nextCheckedState;
  }

  public handleChange() {
    this.setState({
      checkedState: !this.state.checkedState
    });
    if (this.props.onToggleClick) {
      this.props.onToggleClick();
    }
  };

  public render() {
    const { locked } = this.props;
    const { checkedState } = this.state;

    return (
      <Switch
        size="small"
        color="secondary"
        className={classNames(
          'pivot-config-toggle-switch',
          locked ? 'locked' : 'unlocked'
        )}
        checked={checkedState}
        disabled={locked}
        onChange={() => this.handleChange()}
      />
    );
  }
}
